import { FormSchemaDto } from "@amzn/crowd-front-end-common-library";

const deleteTeamFormSchema: FormSchemaDto = {
  groups: [
    {
      groupLabel: "Delete team",
      groupId: "general-group",
      fieldDefinitions: [
        {
          propertyName: "frictionInputValue",
          label: "delete",
          propertyType: "string",
          placeholder: "delete",
          hidden: false,
        },
      ],
    },
  ],
};

export default deleteTeamFormSchema;
